import { render, staticRenderFns } from "./procurement.vue?vue&type=template&id=90046ecc&scoped=true"
import script from "./procurement.vue?vue&type=script&lang=js"
export * from "./procurement.vue?vue&type=script&lang=js"
import style0 from "./procurement.vue?vue&type=style&index=0&id=90046ecc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90046ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90046ecc')) {
      api.createRecord('90046ecc', component.options)
    } else {
      api.reload('90046ecc', component.options)
    }
    module.hot.accept("./procurement.vue?vue&type=template&id=90046ecc&scoped=true", function () {
      api.rerender('90046ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/procurement.vue"
export default component.exports